export const oAuthConfig = {
  googleOAuthClientId: '184337002287-oa25qa94pqe2tpkqk01o5uc6geqks6qk.apps.googleusercontent.com',
};
